import { SharedLinkExpiryDuration } from "@iventis/domain-model/model/sharedLinkExpiryDuration";

export const SharedLinkExpiryDurationToDays = (duration: SharedLinkExpiryDuration) => {
    switch (duration) {
        case SharedLinkExpiryDuration.ThreeDays:
            return 3;
        case SharedLinkExpiryDuration.SevenDays:
            return 7;
        case SharedLinkExpiryDuration.FourteenDays:
            return 14;
        case SharedLinkExpiryDuration.ThirtyDays:
            return 30;
        default:
            return 7;
    }
};
